import type { PoiDetailProps } from '@/components/feature/shop/shop-poi-modal/poi-detail-horizontal';

export type FloorGuidePoiDetailTabOrders = {
    name: number;
    meta: number;
    image: number;
    shopInfo: number[];
    brandDesc?: number;
    guide: number;
    carousel: number[];
    close: number;
};

type BuildTabOrdersOptions = {
    carouselCount?: number;
};

export const buildMinimalPoiModalTabOrders = ({ showLocationCheck = true }: { showLocationCheck?: boolean } = {}) => {
    let order = 1;

    return {
        name: order++,
        floor: order++,
        location: showLocationCheck ? order++ : -1,
        guide: order++,
        close: order++,
    };
};

export const buildFloorGuidePoiDetailTabOrders = (
    poiDetail: PoiDetailProps | null,
    { carouselCount = 0 }: BuildTabOrdersOptions = {}
): FloorGuidePoiDetailTabOrders => {
    let order = 1;
    const name = order++;
    const meta = order++;
    const image = order++;
    const shopInfo = (poiDetail?.listContent ?? []).map(() => order++);
    const brandDesc = poiDetail?.listContent?.length ? order++ : undefined;
    const guide = order++;
    const carousel = carouselCount > 1 ? Array.from({ length: carouselCount }, () => order++) : [];
    const close = order++;

    return { name, meta, image, shopInfo, brandDesc, guide, carousel, close };
};
